/**
 * Owner: Masa Bayu
 * File: OfflinePackagePanel.tsx
 * Date:Time: 2026-09-16 18:53
 * Description: T8-E2 OfflinePackage UI — entitlement-gated; ≠ grant · ≠ Flip.
 */

import { useId, useState } from 'react';
import {
  denyDemoOfflinePackage,
  getDemoAdvancedStatus,
  getDemoOfflinePackage,
  prepareDemoOfflinePackage,
  purgeDemoOfflinePackage,
  resetDemoAdvancedStore,
} from './demo-advanced-store';

export interface OfflinePackagePanelProps {
  readonly onNavigate: (path: string) => void;
}

export function OfflinePackagePanel({ onNavigate }: OfflinePackagePanelProps) {
  const statusId = useId();
  const [status, setStatus] = useState(() => getDemoAdvancedStatus());
  const [pkg, setPkg] = useState(() => getDemoOfflinePackage());

  const refresh = (next: string) => {
    setStatus(next);
    setPkg(getDemoOfflinePackage());
  };

  return (
    <section className="route-panel offline-package" aria-labelledby="offline-package-title">
      <h2 id="offline-package-title">Offline · package</h2>
      <p>
        OfflinePackage prepare requires active entitlement. Package is not an entitlement grant and
        does not execute Flip.
      </p>
      <p id={statusId} role="status" aria-live="polite" className="offline-package__status">
        {status}
        {pkg !== null ? ` · state ${pkg.state}` : ''}
      </p>
      <div role="group" aria-label="Offline package actions" className="offline-package__controls">
        <button
          type="button"
          onClick={() => {
            refresh(prepareDemoOfflinePackage());
          }}
        >
          Prepare package
        </button>
        <button
          type="button"
          onClick={() => {
            refresh(denyDemoOfflinePackage());
          }}
        >
          Deny without entitlement
        </button>
        <button
          type="button"
          onClick={() => {
            refresh(purgeDemoOfflinePackage());
          }}
        >
          Purge on revoke
        </button>
        <button
          type="button"
          onClick={() => {
            resetDemoAdvancedStore();
            refresh(getDemoAdvancedStatus());
          }}
        >
          Reset demo
        </button>
        <button
          type="button"
          onClick={() => {
            onNavigate('/offline');
          }}
        >
          PWA
        </button>
      </div>
      {pkg !== null ? (
        <ul aria-label="Offline package facts" className="offline-package__facts">
          <li>{`grantsEntitlement=${String(pkg.grantsEntitlement)}`}</li>
          <li>{`mutatesQxp=${String(pkg.mutatesQxp)}`}</li>
          <li>{`executesFlip=${String(pkg.executesFlip)}`}</li>
        </ul>
      ) : null}
    </section>
  );
}
